export default __webpack_public_path__ + "static/media/other_filters.f1ab7635.png";